import type { DocumentNode } from '../types/documents';

export type DocumentPreviewKind = 'pdf' | 'image' | 'text' | 'unsupported';

const TEXT_MIMES = new Set([
  'text/plain', 'text/markdown', 'text/csv', 'text/tab-separated-values',
  'application/json', 'application/x-ndjson',
]);
const IMAGE_MIMES = new Set(['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/bmp']);
const EXTENSIONS: Record<string, DocumentPreviewKind> = {
  pdf: 'pdf', png: 'image', jpg: 'image', jpeg: 'image', gif: 'image', webp: 'image', bmp: 'image',
  txt: 'text', md: 'text', csv: 'text', tsv: 'text', log: 'text', json: 'text', jsonl: 'text',
};

/** Classifica tramite MIME verificato; usa l'estensione solo quando il MIME manca. */
export function classifyDocumentPreview(node: Pick<DocumentNode, 'name' | 'content_type'>): DocumentPreviewKind {
  const mime = (node.content_type || '').split(';', 1)[0].trim().toLowerCase();
  if (mime) {
    if (mime === 'application/pdf') return 'pdf';
    if (IMAGE_MIMES.has(mime)) return 'image';
    if (TEXT_MIMES.has(mime)) return 'text';
    return 'unsupported';
  }
  const extension = node.name.toLowerCase().split('.').pop() || '';
  return EXTENSIONS[extension] || 'unsupported';
}
